var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDesignLayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 3000,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M2412.48457,2051.48159c15.0476-67.41265,82.74814-26.13022,122.25362-9.05168,29.92863,12.1151,64.81331-1.72985,69.90395-35.11669,5.68573-31.76845,1.4292-66.12572,16.475-95.75268,30.31163-69.56839,126.2694-48.49912,124.945,26.91628-18.29032,74.2995,54.89542,84.189,63.62371,33.4397,3.09405-61.79032,74.99663-83.10377,108.55907-30.868,29.94274,44.16192,17.2431,126.96722-38.41967,141.28943-15.95166,3.64519-32.55325.17358-48.91333-.12135-87.81527,4.69435-25.09268,67.684-40.55161,112.48029-8.0013,17.15124-30.13656,23.86984-48.64662,19.934-41.61065-5.302-77.69722-80.26775-120.77321-42.32133-9.97228,12.507-6.0588,30.61289-8.43813,46.42994-4.47713,29.76257-32.82682,51.36762-62.276,57.58034-59.49819,12.45338-119.28387-23.78682-178.84148-12.75672-28.46336,5.30048-58.61814,21.1218-84.48265,8.11085-43.42405-19.52184-38.721-129.32924-14.14279-161.25869,16.7317-21.7647,45.23535-30.06176,71.77081-37.09288C2369.05579,2066.82382,2387.959,2057.98017,2412.48457,2051.48159Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2263.42968 2113.7858c22.64378 4.82887 45.52347 9.68195 68.67332 9.30354s46.93377-6.45912 64.70613-21.29833 28.29891-39.47291 22.41039-61.86452c-5.76086-21.90618-25.95987-40.64776-22.458-63.02643 3.64186-23.273 31.05647-34.69981 54.60838-35.15132s47.82858 5.51552 70.26086-1.674c21.88474-7.014 39.02109-27.06638 42.53839-49.77689s-6.75049-47.00709-25.48823-60.31256c-10.11463-7.18228-22.11643-11.17968-32.87877-17.34918s-20.86821-15.60757-22.67322-27.88082c-3.21514-21.8615 19.55633-37.3737 32.50442-55.27928 19.32692-26.72668 16.19326-66.52907-5.16656-91.6608s-58.17061-34.88314-90.00342-26.25076-57.90829 34.16082-69.964 64.86107c-9.19391 23.41262-10.76362 49.1581-18.73818 73.01361-19.07444 57.06025-77.77679 98.31865-137.925 96.93928-25.50354-.58486-52.57141-7.75192-75.52408 3.38125-29.01806 14.07518-38.30591 52.47854-31.38854 83.97947a124.07062 124.07062 0 0054.37113 77.40786c21.41393 13.49388 34.36113 36.70355 57.17155 47.67287 17.6373 8.4816 37.26343 14.27842 51.22927 27.98853C2257.2514 2094.22585 2260.77118 2103.53684 2263.42968 2113.7858zM2460.93358 1841.60017s-48.06447 29.79392-90.79171 16.20942"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.466,
    d: "M2307.90927 2194.346s283.19494-45.0024 414.21-154.01252M2691.76347 1980.41434s12.05694 65.64955-24.45981 97.49021M2723.79713 2111.94892s-27.6319 17.44814-101.16983-10.83831M2539.403 2086.29466s4.23168 41.48971-22.72872 56.34987M2520.38962 2199.28271s-62.12327-7.4356-65.02777-38.10743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2431.29735 1654.47645s-22.19645 137.357-61.15548 203.33314-137.18884 133.827-134.756 170.9143M2356.7197 1975.46423c.19727 3.00708-26.93142 39.0136-95.37217 6.25629M2263.48592 1873.94033s-7.71642 67.52374 15.35815 88.838M2454.80476 1676.0879s-4.87682 25.35708-33.90177 31.35261"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 721.001,
    cy: 2468.808,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    rx: 455.857,
    ry: 118.185
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M194.74923,2286.5443H2372.08507c3.72348-5.37386,42.99691-64.08272,18.516-128.23989-21.69269-56.85042-84.1807-93.70031-152.242-86.40765,18.00959-122.01749-10.6439-244.099-88.465-298.31213-114.97143-80.09353-352.82157-22.89635-479.35707,205.73245,12.34417-150.1847-86.40744-267.45223-216.01892-325.05733-173.50108-61.71976-265.82157,74.48408-306.54127,111.09559-50.3335-55.37443-130.46-124.5804-244.82175-162.52875-132.00119-43.80154-365.52707-64.51333-454.669,65.83443-31.63646,46.26054-36.99129,99.70946-34.97454,141.95541-125.11529-40.35954-260.6718,15.41838-318.88535,127.55421C32.272,2058.28211,74.51739,2212.49643,194.74923,2286.5443Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.127,
    height: 308.599,
    x: 1338.622,
    y: 1451.27,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    points: "1506.496 1729.695 1318.876 1729.695 777.201 1975.202 939.286 1975.202 1412.686 1814.731 1886.086 1975.202 2048.171 1975.202 1506.496 1729.695"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1752.841,
    height: 279.314,
    x: 462.202,
    y: 1975.202,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1867.138,
    x2: 1867.138,
    y1: 2009.054,
    y2: 2223.346,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1752.841,
    height: 32.028,
    x: 462.202,
    y: 2254.516,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1031.399,
    x2: 1031.399,
    y1: 2009.054,
    y2: 2223.346,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.287,
    x2: 735.287,
    y1: 2009.054,
    y2: 2223.346,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.695,
    x2: 2481.192,
    y1: 2286.544,
    y2: 2286.544,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.466
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1703.465,
    height: 1050.607,
    x: 551.352,
    y: 413.007,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    rx: 39.208
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2208.18978,532.42051V1344.1861a75.43952,75.43952,0,0,1-75.43918,75.4393H1857.06344V457.00048H2132.7506A75.43548,75.43548,0,0,1,2208.18978,532.42051Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1259.072,
    height: 442.766,
    x: 597.992,
    y: 653.285,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1176.657,
    height: 381.829,
    x: 639.83,
    y: 681.375,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: 21.862,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1857.06344 457.00048V653.285H597.99189V532.42051a75.41874 75.41874 0 0175.41992-75.42zM1857.06344 1096.05046V1419.6254H673.41181a75.42278 75.42278 0 01-75.41992-75.4393V1096.05046z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2038.113,
    cy: 797.041,
    r: 63.091,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1600.506,
    cy: 894.987,
    r: 63.091,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1356.808,
    cy: 559.722,
    r: 63.091,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1529.343,
    cy: 1266.666,
    r: 63.091,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.79084 582.048v-3.64813l4.65957-4.52525c11.21394-10.674 16.28093-16.34765 16.34854-22.96783 0-4.45853-2.16166-8.579-8.71424-8.579a14.95709 14.95709 0 00-9.3227 3.71485l-1.89123-4.1881a19.27231 19.27231 0 0112.42909-4.45853c9.45792 0 13.44319 6.485 13.44319 12.768 0 8.10578-5.8765 14.65836-15.1316 23.57542l-3.512 3.24248v.13522h19.72535V582.048zM1588.41442 910.11889a19.86406 19.86406 0 009.72657 2.77012c7.6343 0 9.99878-4.86417 9.93117-8.51141-.0676-6.14783-5.60785-8.78185-11.34914-8.78185h-3.30921v-4.45853h3.30921c4.32331 0 9.796-2.22927 9.796-7.43059 0-3.51291-2.22926-6.62019-7.7019-6.62019a16.12735 16.12735 0 00-8.78185 2.90445l-1.55319-4.32331a20.87721 20.87721 0 0111.48436-3.3777c8.64663 0 12.5643 5.1346 12.5643 10.47114 0 4.52525-2.70251 8.3762-8.10577 10.335v.13521c5.40326 1.08083 9.79418 5.13371 9.79418 11.28154 0 7.02494-5.47086 13.17188-16.0105 13.17188a22.31551 22.31551 0 01-11.415-2.97206zM2039.70049 780.62615h-.13522l-7.6343 4.12049-1.14754-4.52614 9.59135-5.13371h5.067v43.90834h-5.74129zM1533.665 1288.62015v-11.95672h-20.39964v-3.91767l19.58835-28.03394h6.41915v27.29026h6.14693v4.66135h-6.14693v11.95672zm0-16.61807v-14.65835q0-3.44532.20282-6.89062h-.20282c-1.35037 2.5673-2.43209 4.45853-3.64724 6.485l-10.74068 14.92967v.13433z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1176.657,
    height: 244.785,
    x: 639.83,
    y: 1136.725,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: 21.862,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1000.38293,873.21064s-13.41038-5.49388,10.51521-17.373,50.74736,28.34537,49.833,42.51805-41.60369,37.94622-41.60369,37.94622Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1073.91291,792.92217s-22.402-19.65475-35.20312,10.97654-30.2884,68.92039-30.2884,68.92039,19.87778,31.22589,32.67892,28.48279C1101.001,874.66771,1073.91291,792.92217,1073.91291,792.92217Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    points: "1080.818 671.773 1399.885 699.204 1358.738 936.025 1050.597 891.221 1080.818 671.773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1239.73823,791.32617l81.73946-45.26116,6.40057,8.91508-90.29371,48.69S1234.80557,797.95532,1239.73823,791.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M787.94472,840.93056s-209.84716,204.361-162.52868,304.48411c30.1741,56.91933,121.38218-3.42887,121.38218-3.42887Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M874.31012,2394.6288l3.01386-14.81914s-75.43518-9.3932-85.03587-4.69671c0,0-3.83494,7.965-8.48785,19.78806C811.24753,2404.1461,844.58332,2401.09665,874.31012,2394.6288Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M936.758,2409.98369c-27.88805-2.28575-64.92-3.20023-64.92-3.20023l2.47212-12.15466c-29.7268,6.46785-63.06259,9.5173-90.50986.27221-12.12263,30.8054-29.80641,87.8447.25842,98.74728,41.60346,15.08713,146.7561-16.91564,180.58738-41.14644C975.61847,2441.98668,964.64606,2412.26989,936.758,2409.98369Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M538.81062,2381.89726l5.12882-23.04923s-62.765-22.00443-73.35181-20.53619a307.59609,307.59609,0,0,0-20.84976,27.64075C475.26856,2386.27,507.47281,2388.19765,538.81062,2381.89726Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M596.977 2416.49935c-25.78466-10.86922-60.68431-23.28719-60.68431-23.28719l2.51793-11.3149c-31.33781 6.30039-63.54206 4.37269-89.07275-15.94467-17.51566 26.14405-36.50956 63.82383-14.89231 80.77661 34.82359 27.30983 135.66715 31.33625 175.36826 18.86513C623.91855 2459.02574 622.76122 2427.369 596.977 2416.49935zM1058.82586 1316.85843s-288.02552-23.31635-339.45864 14.40128-139.21234 237.96393-91.20808 523.24635c-94.637 160.47135-170.07221 492.38647-170.07221 492.38647s60.80538 35.20312 86.40765 26.97382c37.03185-54.862 211.21871-354.77428 285.28242-668.85925 60.3482-194.76011 100.12315-283.91086 100.12315-283.91086"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M885.32477,1295.59941c2.7431,0,207.89735,17.06216,212.644,27.73278s10.23287,298.01036-26.799,477.68341-176.01559,587.9378-176.01559,587.9378-103.32344,11.88677-117.95331-9.14367c3.65747-59.43383,72.235-443.46785,106.98091-500.15859-11.88677-61.26257-92.84225-250.23826-55.79177-387.35614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M718.8363,1346.26487s31.38618,18.61526,109.95986,19.914,179.22592-19.04816,214.29186-19.914,56.49139-8.69938,56.49139-8.69938v-27.83343l-380.74311,12.2897-7.28621,15.96351Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M845.54982,816.92843s-58.29088-16.4586-116.58175,87.77921-41.14651,403.23572-9.60085,426.55207,155.67093,28.80255,201.61786,19.88747,133.72613-10.28662,161.8429-16.4586,35.6603-72.69215,32.23143-133.04035-2.98023-291.64866-148.12741-365.5181C892.8683,801.84138,845.54982,816.92843,845.54982,816.92843Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M890.811,948.59724s39.53759,267.89,242.76437,213.96181c174.87263-46.40411,132.81176-309.74172,132.81176-309.74172s-.45718-4.57184-13.25832-4.57184-47.54707-13.25831-47.54707,6.85775-9.11317,136.8453-61.26257,148.99848-76.2389-61.85423-84.92538-75.11255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1255.4147,856.2462s32.46-44.11819,25.60227-58.97665-39.77495-30.40269-48.00425-32.00284-32.91721,17.14438-34.97453,23.31636,2.28592,26.51663,5.94338,31.31706,11.201,29.48832,11.201,32.00283S1255.4147,856.2462,1255.4147,856.2462Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1233.92708,787.44011s-14.85846,14.85846-5.71479,24.6879-6.172,16.68719-6.172,16.68719"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    points: "1199.37 807.115 1180.894 817.157 1170.836 825.615 1185.466 825.615 1203.982 819.9 1199.37 807.115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M875.03815,765.553s29.94551,3.88606,48.69-7.08634c38.86058-31.08847-37.26045-155.67093-37.26045-155.67093s-131.21162,67.206-131.21162,68.5775,27.88818,87.77921,29.71692,88.23639,25.14508,8.68648,25.14508,8.68648,5.4862,34.28875-1.37155,57.60511c13.25832,16.4586,72.69216,22.402,104.695,2.28591,9.14367-6.40056,2.97169-11.94444,2.97169-11.94444s-14.42366-40.23869-16.00906-50.75391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M902.119 772.81771s-24.45776-1.1364-29.328-6.81838c28.40991.97406 27.59819.81171 27.59819.81171zM830.23418 691.48928s-42.97524-39.31777-48.00425 4.11465 29.71692 29.71692 42.06087 28.80255c0 0 6.40056 21.03044 0 35.20312s-46.17552 44.804-64.00567 28.80255-50.74736-80.17979-48.00426-113.23923 16.4586-60.49044 39.31777-73.29158 106.98091-32.00283 114.753-59.891c3.65747-15.087 21.94481-4.57183 30.63129 14.62987s24.23072 26.05945 10.058 40.23213-71.77778 33.83157-78.63553 35.66031c1.37155 32.00283 21.03043 59.43383 17.83015 60.3482S834.34883 699.2614 830.23418 691.48928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M1050.59656 816.36521s22.4264-.12255 20.12827 17.36471-20.12827 22.51628-20.12827 22.51628M174.1187 1390.791c0 1.56262.06411 3.093.16086 4.62356a70.33945 70.33945 0 1154.95145-67.25933A63.14278 63.14278 0 00174.1187 1390.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822,
    d: "M300.42109,1390.791a63.15566,63.15566,0,0,1-126.14153,4.62356,70.37211,70.37211,0,0,0,54.95145-67.25933,63.13888,63.13888,0,0,1,71.19008,62.63577Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2040.473,
    cy: 1090.512,
    r: 69.111,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2077.594,1121.34729h-74.24082s-.6892-8.59213,3.77693-10.65974c4.47509-2.05818,7.90271-44.3292,20.63-49.48453,1.98482-.80878,3.65734-1.48878,5.07231-2.0584a8.09679,8.09679,0,0,1-.61561-3.09692,8.252,8.252,0,1,1,15.89762,3.09692c1.406.56962,3.08773,1.24962,5.07255,2.0584,12.71814,5.15533,16.155,47.42635,20.62085,49.48453C2078.274,1112.75516,2077.594,1121.34729,2077.594,1121.34729Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2052.35086,1121.34729a11.88189,11.88189,0,0,1-23.76377,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.122,
    height: 57.144,
    x: 1907.615,
    y: 2088.277,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.122,
    height: 57.144,
    x: 1058.826,
    y: 2088.277,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.122,
    height: 57.144,
    x: 752.396,
    y: 2088.277,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("rect", {
    width: 218.188,
    height: 52.642,
    x: 1923.533,
    y: 537.396,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822
  }), /*#__PURE__*/React.createElement("rect", {
    width: 218.188,
    height: 52.642,
    x: 1923.533,
    y: 1328.869,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822
  }), /*#__PURE__*/React.createElement("rect", {
    width: 218.188,
    height: 52.642,
    x: 1923.533,
    y: 1218.391,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.822
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2562.13305,1418.59268l-29.48823-8.34245a9.87473,9.87473,0,0,0-8.99154,1.90066l-23.58964,19.56224a9.87474,9.87474,0,0,1-16.17085-7.22149l-1.17822-30.62293a9.8747,9.8747,0,0,0-4.58618-7.96413l-25.89438-16.39a9.87473,9.87473,0,0,1,1.871-17.611l28.76-10.58356a9.87472,9.87472,0,0,0,6.15713-6.82277l7.586-29.69182a9.87473,9.87473,0,0,1,17.32717-3.66268l18.95291,24.08194a9.87475,9.87475,0,0,0,8.3915,3.74743l30.58281-1.96054a9.87473,9.87473,0,0,1,8.8378,15.34729l-17.04651,25.467a9.87474,9.87474,0,0,0-.9709,9.13881l11.31519,28.48014A9.87473,9.87473,0,0,1,2562.13305,1418.59268Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.832,
    height: 157.832,
    x: 321.297,
    y: 942.485,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.212,
    x2: 400.212,
    y1: 969.452,
    y2: 1073.351,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.449,
    x2: 450.677,
    y1: 1021.401,
    y2: 1021.401,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2528.159,
    cy: 703.593,
    r: 100.798,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.644,
    d: "M2584.61691,692.502h-9.85309v61.39557h-31.6139V723.38762a13.76348,13.76348,0,1,0-27.52695,0v30.50992h-31.62154V692.502h-12.29961l55.50038-54.31811Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesignLayout);
export default __webpack_public_path__ + "static/media/web-design-layout.7a9922f4d8898ccbb3798ade736c7382.svg";
export { ForwardRef as ReactComponent };